
const digest = '1fa0021a38ae304d816c21eef677bc1c241951386ad459e0208440f90ca13b6b';
const classes = {"wrapper":"_wrapper_l8hr7_1","active":"_active_l8hr7_10"};
const css = `._wrapper_l8hr7_1 {
  display: flex;
  gap: 4px;
  align-items: center;
  cursor: pointer;
  color: #1665D8;
  opacity: 0.5;
}

._active_l8hr7_10 {
  opacity: 1;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  